import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form } from "antd";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants/input-types";
import "styles/form.css";

const FIELDS = new OrderedMap({
    document_id: {
        type: INPUT_TYPES.SELECT,
        // placeholder: "Document Type",
        filterOption: (value, option) => {
            if (value) {
                return (
                    option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                );
            }
            return true;
        },
        optionFilterProp: "label",
        optionLabelProp: "label",
        dropdownMatchSelectWidth: false,
        showSearch: true,
        style: {},
        label: "Document Type",
        rules: [
            {
                required: true,
                message: "Document Type is required"
            }
        ],
        className: "mr-5 mb-0",
    },
    remarks: {
        key: "remarks",
        type: INPUT_TYPES.TEXTAREA,
        label: "Remarks",
        className: "form-field fb-50",
    },
    file: {
        key: "file",
        type: INPUT_TYPES.FILE,
        btnLabel: "Upload New Attachment",
        showUploadList: false,
        rules: [
            {
                required: "true"
            }
        ],
        className: "form-field fb-50",
    }
});

class CompanyAttachmentUploadForm extends React.Component {

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    render() {
        return (
            <Form
                layout="vertical"
                hideRequiredMark={false}
                className={cx("form", "br-3")}>
                {FIELDS
                    .setIn(["document_id", "options"], this.props.docMasterGroups)
                    .map((field, fieldName) => {
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    })
                    .toList()}
            </Form>
        );
    }
}

CompanyAttachmentUploadForm.propTypes = {
    values: PropTypes.object,
    form: PropTypes.object,
    onSubmit: PropTypes.func,
    schemesList: PropTypes.array,
    companyId: PropTypes.number,
    brands: PropTypes.array,
    onUpdateSchemeMapping: PropTypes.func,
    docMasterGroups: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values
            .map((value) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS()
})(CompanyAttachmentUploadForm);